import { Error } from './Error';

export default class ValidationResult {
	missingSettings: Set<string>;

	productErrors: Error[];

	countryErrors: Error[];

	constructor(missingSettings: Set<string>, productErrors: Error[], countryErrors: Error[]) {
		this.missingSettings = missingSettings;
		this.productErrors = productErrors;
		this.countryErrors = countryErrors;
	}

	isMissingCifPrice(): boolean {
		return this.missingSettings.has('proposed-cif-price');
	}

	isMissingNationality(): boolean {
		return this.missingSettings.has('country-of-origin-nationality');
	}

	isMissingPrice(): boolean {
		return this.missingSettings.has('country-of-origin-price');
	}
}
